import * as UIUtil from "/app/js/util/UI.js";
import * as Menu from "/app/js/common/Menu.js";
import * as Information from "/app/js/common/Information.js";
import {openFooter} from "../common/Menu.js";

export const init = async function () {

    const htmlUrl = `Footer.html`;
    // .headerWrap의 다음에 htmlUrl를 fetch하여 삽입한다.
    const target =
        (Menu.getActiveMenuKey() === 'Main' || Menu.getActiveMenuKey() === '')
        ? document.querySelector(".sub-section.news") || document.querySelector("#wrap")  // 이 줄이 핵심
        : document.querySelector("#wrap");
    await UIUtil.load(target, htmlUrl, true).then(() => {
        const selectedLang = $('.btn-lang').text();
        UIUtil.changeLang(selectedLang, false);
        UIUtil.initCommonUI();
        initEvt();
    });
}

function initEvt() {
    document.querySelectorAll('.service > a').forEach(function (el){
        el.addEventListener('click', function (e) {

            const menuKey = this.parentElement.getAttribute("key");

            const key = el.getAttribute('key');

            Menu.openFooter(menuKey, key);

            // Information.openInformation(menuKey);

            // const tabMap = {
            //     "Information_Privacy": "tab01",
            //     "Information_LBS": "tab02",
            //     "Information_Email": "tab03",
            //     "Information_Contact": "tab04"
            // };
            //
            // const tabClass = tabMap[key];
            //
            // if (tabClass) {
            //
            //     const lang = document.documentElement.lang;
            //     const htmlUrl = `app/html/${lang}/main/Information.html`;
            //
            //     // Pass the tab identifier to Information.js via session storage
            //     // sessionStorage.setItem('activeTab', tabClass);
            //     // Navigate to the Information.html page
            //     window.location.href = htmlUrl;
            // }
        });
    });



}